import type { FC } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import { useFallbackImageSrc } from "src/shared/hooks/useFallbackImageSrc";
import {
  StyledImageContainer,
  StyledImmersiveImage,
  StyledVenueCategoryTitleVariant,
  StyledVenueHeroContentArea,
  StyledVenueHeroInfo,
} from "src/website-apps/shared/components/ancillary-pages/BigImmersiveHeader.styled";
import { ImageSize } from "src/website-apps/shared/components/image";
import { venueFullGradientStyle, venueHeroHeaderStyle } from "./VenueHeroHeader.styles";
import { VenueSubtitle } from "./VenueSubtitle";

const locationTextStyle = css({
  textStyle: "label.medium",
  color: "[white]",
  whiteSpace: "nowrap",
  overflowX: "hidden",
  overflowY: "hidden",
  textOverflow: "ellipsis",
});

interface VenueHeroHeaderProps {
  children: React.ReactNode;
  headerTitle: string;
  venueCityName: string | null | undefined;
  venueStateProvinceName: string | null | undefined;
  eventCount: number;
  imageUrl: string;
}

export const VenueHeroHeader: FC<VenueHeroHeaderProps> = ({
  children,
  headerTitle,
  venueCityName,
  venueStateProvinceName,
  eventCount,
  imageUrl,
}) => {
  const fallbackImageSrc = useFallbackImageSrc();

  return (
    <div className={venueHeroHeaderStyle} data-theme="dark">
      {children}
      <StyledImageContainer>
        <StyledImmersiveImage
          alt={headerTitle}
          fallbackImageSrc={fallbackImageSrc}
          size={ImageSize.GlassImage}
          src={imageUrl}
        />
        <div className={venueFullGradientStyle} />
      </StyledImageContainer>
      <StyledVenueHeroContentArea>
        <StyledVenueHeroInfo $condensed>
          <StyledVenueCategoryTitleVariant as="h1">{headerTitle}</StyledVenueCategoryTitleVariant>
          <VenueSubtitle
            className={locationTextStyle}
            eventCount={eventCount}
            venueCityName={venueCityName}
            venueStateProvinceName={venueStateProvinceName}
          />
        </StyledVenueHeroInfo>
      </StyledVenueHeroContentArea>
    </div>
  );
};
